/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const API = "https://backend.hira-tech.co.uk";
// ⚠️ Apne router ke hisaab se ye path adjust karein (PlaceOrders wala route)
const PLACE_ORDER_PATH = "/admin/placeorders";

const DraftOrders = () => {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDrafts = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/order/drafts/`);
      if (!res.ok) throw new Error("Failed to fetch drafts");
      setDrafts(await res.json());
    } catch (e) {
      console.error("Error fetching drafts:", e);
      setDrafts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts();
  }, []);

  const handleContinue = (id) => {
    navigate(`${PLACE_ORDER_PATH}?draft=${id}`);
  };

  const handleDelete = async (draft) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Delete draft?",
      text: `"${draft.title || "Untitled draft"}" will be permanently deleted.`,
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete"
    });
    if (!result.isConfirmed) return;

    try {
      const res = await fetch(`${API}/order/drafts/${draft.draft_id}/`, { method: "DELETE" });
      if (!res.ok && res.status !== 204) throw new Error("Delete failed");
      setDrafts((prev) => prev.filter((d) => d.draft_id !== draft.draft_id));
    } catch (e) {
      Swal.fire({
        icon: "error", title: "Error", text: "Could not delete draft.",
        confirmButtonColor: "#004aad"
      });
    }
  };

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleString([], {
        day: "2-digit", month: "short", year: "numeric",
        hour: "2-digit", minute: "2-digit"
      });
    } catch {
      return iso;
    }
  };

  const productCount = (d) =>
    Array.isArray(d.data?.products) ? d.data.products.filter((p) => p.productId).length : 0;

  const styles = `
    .drafts-container { font-family: 'Inter', sans-serif; padding: 24px; max-width: 1500px; margin: 0 auto; }
    .drafts-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
    .drafts-title { font-size: 22px; font-weight: 600; color: #004aad; margin: 0; }
    .drafts-new-btn { background: #004aad; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; font-size: 13px; cursor: pointer; }
    .drafts-new-btn:hover { background: #00388c; }
    .drafts-table-wrap { background: #f4f4f4; border: 1px solid #e2e6ea; padding: 12px; overflow-x: auto; }
    .drafts-table { width: 100%; border-collapse: collapse; background: #fff; }
    .drafts-table th { text-align: left; font-size: 13px; color: #004aad; padding: 10px 12px; border-bottom: 2px solid #e2e6ea; }
    .drafts-table td { font-size: 14px; padding: 10px 12px; border-bottom: 1px solid #eee; }
    .drafts-table tr:hover td { background: #f9fbff; }
    .drafts-actions { display: flex; gap: 8px; }
    .btn-continue { background: #004aad; color: #fff; border: none; padding: 5px 12px; border-radius: 4px; font-size: 12px; cursor: pointer; }
    .btn-continue:hover { background: #00388c; }
    .btn-delete { background: #ff6b6b; color: #fff; border: none; padding: 5px 12px; border-radius: 4px; font-size: 12px; cursor: pointer; }
    .btn-delete:hover { background: #ff5252; }
    .drafts-empty { text-align: center; color: #666; padding: 30px 0; font-size: 14px; }
  `;

  return (
    <div>
      <style>{styles}</style>
      <div className="drafts-container">
        <div className="drafts-header">
          <h2 className="drafts-title">Order Drafts</h2>
          <button className="drafts-new-btn" onClick={() => navigate(PLACE_ORDER_PATH)}>
            + New Order
          </button>
        </div>

        <div className="drafts-table-wrap">
          {loading ? (
            <div className="drafts-empty">Loading drafts...</div>
          ) : drafts.length === 0 ? (
            <div className="drafts-empty">No drafts yet. Start filling an order and it will be saved here automatically.</div>
          ) : (
            <table className="drafts-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Draft</th>
                  <th>Customer Reference</th>
                  <th>Products</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {drafts.map((d, i) => (
                  <tr key={d.draft_id}>
                    <td>{i + 1}</td>
                    <td>{d.title || "Untitled draft"}</td>
                    <td>{d.data?.customerReference || "-"}</td>
                    <td>{productCount(d)}</td>
                    <td>{formatDate(d.updated_at)}</td>
                    <td>
                      <div className="drafts-actions">
                        <button className="btn-continue" onClick={() => handleContinue(d.draft_id)}>
                          Continue
                        </button>
                        <button className="btn-delete" onClick={() => handleDelete(d)}>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default DraftOrders;